import * as moment from 'moment-timezone';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { ITestWindow, MyCtrlOrgService } from '../my-ctrl-org.service';
import { AuthService, DB_TIMEZONE } from '../../api/auth.service';
import { RoutesService } from '../../api/routes.service';
import { ScrollService } from '../../core/scroll.service';
import { LangService } from '../../core/lang.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BreadcrumbsService, IBreadcrumbRoute } from '../../core/breadcrumbs.service';
import { ITestWindowSummary, IAccountsSummary } from './types/db';
import { FormControl } from '@angular/forms';
import { WhitelabelService } from '../../domain/whitelabel.service';
import { userGroupTypes, userGroupSummaryColumns } from './types/tc-summary';
import { CODEBOOK_G9, tcDataDlApiPrefix } from './types/codebook-g9';
import { transformThousandsSeparator } from '../../core/styleprofile.service'
import { mtz } from '../../core/util/moment';

// interface ITestWindow {
//   id: number,
//   captionStr: string,
//   dateStart: string
//   dateEnd: string,
//   numSessionsCreated: number,
//   numSessionsAdministered: number,
//   numResultsPendingRelease: number,
// }

interface ILangReqRow {
  testSessionId: number,
  date: string,
  time: string,
  location:string,
  locationInst: string,
  locationDetails: string,
  lang: string,
  tally: number,
  isOrganized:boolean,
  notes: string,
  __notesInput: FormControl,
  __isShowLocDetail?: boolean,
}

export interface ILangReqRecord {
  id: number, // test session id
  test_window_id: number,
  lang_req: string,
  tally: number,
  institution_name: string,
  room: string,
  campus_building: string,
  address: string,
  city: string,
  province: string,
  postal_code: string,
  phone_number: string,
  date_time_start: string,
}
 enum UserGroupType {
  SCHOOL_BOARDS = 'districts',
  SCHOOLS = 'schools',
  TEACHERS = 'teachers',
  SCHOOL_CLASSES = 'classes',
  STUDENTS = 'students',
}

export enum SummaryCol {
  Registered = 'Registered',
  BoardCompletedTech = 'BoardCompletedTech',
  CompletedTech = 'CompletedTech',
  CompletedSample = 'CompletedSample',
  CompletedSampleAndTech = 'CompletedSampleAndTech',
  StartedOper = 'StartedOper',
  CompletedOper = 'CompletedOper',
  StuReportsAccessed = 'StuReportsAccessed',
}

export enum TCView {
  EQAO_G9 = 'EQAO_G9',
  EQAO_G10 = 'EQAO_G10',
  EQAO_MPT = 'EQAO_MPT',
}


@Component({
  selector: 'view-tc-dashboard',
  templateUrl: './view-tc-dashboard.component.html',
  styleUrls: ['./view-tc-dashboard.component.scss']
})
export class ViewTcDashboardComponent implements OnInit, OnDestroy {

  // services
  constructor(
    private loginGuard: LoginGuardService, //
    private router:Router,
    private route:ActivatedRoute,
    private breadcrumbsService:BreadcrumbsService,
    private scrollService:ScrollService,
    private lang:LangService,
    private auth:AuthService,
    private routes:RoutesService,
    private myCtrlOrg:MyCtrlOrgService,
    private whitelabel:WhitelabelService,
  ) { }

  // rendered vars

  public districts = 'districts';
  public isDisableHidden:boolean = true;
  public breadcrumb:IBreadcrumbRoute[];
  public isInited:boolean;
  public isLoaded:boolean = true;
  public isLoadFailed:boolean;
  public summaryTableTimestamp: string;
  public testWindowSummaries:ITestWindow[];
  public testWindowOldSessions = {};
  public accountSummaries:IAccountsSummary;
  public showLast30days = new FormControl(false);
  public showTestSessionInProgressData = new FormControl(false);
  public TCView = TCView;
  // public selectedView:TCView =TCView.EQAO_G9; // to change if ordering by route
  public IS_DOWNLOADS_DISABLED = false;
  public IS_TW_SELECT_DISABLED = true;
  public IS_COUNTS_DISABLED = false;
  public IS_COUNTS_WARNING = false; 
  // public views:IMenuTabConfig<TCView>[] = [
  //   {
  //     id:TCView.EQAO_G9,
  //     caption: this.lang.tra('Grade 9 Mathematics'), //'Technical Readiness',
  //   },
  //   {
  //     id:TCView.EQAO_G10,
  //     caption: this.lang.tra('OSSLT/TPCL'), //'Technical Readiness',
  //   },
  //   {
  //     id:TCView.EQAO_MPT,
  //     caption: this.lang.tra('Math Proficiency Test'), //'Technical Readiness',
  //   }
  // ];
  public userGroupTypes = userGroupTypes;
  public UserGroupType = UserGroupType;
  public userGroupSummaryColumns = userGroupSummaryColumns;
  public codebookTable = CODEBOOK_G9;

  // logical vars
  private routeSub:Subscription;
  private myCtrlOrgSub:Subscription;

  isShowQa:boolean = false;
  isShowBg:boolean = false;
  isFullWidth:boolean;
  loadedDataTracker: TCView;

  // API utility
  currentSummaryColIndex = 0;
  testWindows:ITestWindow[] = [ 
  ];
  summaryTable:{[col:string]: {[row:string]: number}} = {};
  ttriUrl = null;
  twFiles;

  allWinSummaryRecords;
  isLoadingAllWinSummary:boolean;
  allWinGridOptions:any = {
    columnDefs: [
      { headerName:'Administration Window', field:'window_title', width:200 },
      { headerName:'Registered', field:'num_registered', width:200 },
      { headerName:'Fully Participating (Complete)', field:'num_complete', width:200 },
      { headerName:'Remaining to Complete', field:'num_to_complete',width:200 },
      { headerName:'RtC %', field:'perc_to_complete',width:120 },
      { headerName:'Partially Participating (Started)', field:'num_start', width:200 },
      { headerName:'Remaining to Start', field:'num_to_start',width:200 },
      { headerName:'RtS %', field:'perc_to_start',width:120 },
    ],
    defaultColDef: {
      filter: true,
      sortable: true,
      resizable: true,
    },
  };
  async loadAllWinSummary(){
    const summaryLoaders = [];
    const summaryRecords = [];
    this.isLoadingAllWinSummary = true;
    this.testWindows.forEach(window => {
      if (window.is_qa){ return }
      const record = {
        tw_id: window.id,
        window_title: this.renderTwTitle(window.title),
        num_registered: 0,
        num_complete: 0,
        num_to_complete: 0,
        perc_to_complete: '',
        num_start: 0,
        num_to_start: 0,
        perc_to_start: '',
      }
      summaryRecords.push(record);
      const loadRecordField = async (colId: SummaryCol, field:string) => {
        const data = await this.myCtrlOrg.getSummaries(colId, window)
        const val = data.summaryData ? data.summaryData.students : 0;
        record[field] = val;
      }
      [
        loadRecordField(SummaryCol.Registered, 'num_registered'),
        loadRecordField(SummaryCol.CompletedOper, 'num_complete'),
        loadRecordField(SummaryCol.StartedOper, 'num_start'),
      ].forEach( a => summaryLoaders.push(a) )
    })
    await Promise.all(summaryLoaders);
    const formatPerc = num => Math.floor((isNaN(num) ? 0 : num)*100)+'%'
    summaryRecords.forEach(record => {
      record.num_to_complete = record.num_registered - record.num_complete;
      record.num_to_start = record.num_registered - record.num_start;
      record.perc_to_complete = formatPerc(record.num_to_complete/record.num_registered);
      record.perc_to_start = formatPerc(record.num_to_start/record.num_registered);
    })
    this.allWinSummaryRecords = summaryRecords;
    this.isLoadingAllWinSummary = false;
  }
  downloadAllWinSummary(){
    this.allWinGridOptions.api.exportDataAsCsv();
  }
  
  // init / destroy
  ngOnInit() {
    this.scrollService.scrollToTop();
    this.loginGuard.activate([AccountType.TEST_CTRL]);
    this.routeSub = this.route.params.subscribe(routeParams => {
      // this.setupId = routeParams['setupId'];
      this.breadcrumb = [
        this.breadcrumbsService.TESTCTRL_DASHBOARD(),
        // this.breadcrumbsService._CURRENT(this.lang.tra(currentPageNameTrans), this.router.url),
      ]
      this.initRouteView();
    });
  }

  ngOnDestroy() {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }

    if (this.myCtrlOrgSub) {
      this.myCtrlOrgSub.unsubscribe();
    }
  }

  initRouteView(){
    this.myCtrlOrgSub = this.myCtrlOrg.sub().subscribe( async orgInfo => {
      if (!this.isInited && orgInfo){
        this.isInited = true;
        this.testWindows = await this.myCtrlOrg.loadWindows();
      }
    })
  }


  getRoleContext(){
    return {
      tc_group_id: this.myCtrlOrg.selectedWindow?.test_ctrl_group_id,
      test_window_id: this.myCtrlOrg.selectedWindow.id
    }
  }


  showTestWindow(testWindow: ITestWindow)
  {
    return (this.isShowBg && testWindow.is_bg) || 
    (this.isShowQa && testWindow.is_qa) ||
    (!testWindow.is_qa && !testWindow.is_bg)
    ;
  }

  public isGradTW(type_slug: string): boolean
  {
    return type_slug.toLocaleUpperCase() === "BCED_GRAD";
  }

  public goToTWSummaryPageURL(isGrad: boolean): void
  {
    // hardcoding the URLs to be pointing to production right now instead of detecting the
    // current domain and returning bced-uat.vretta.com, bced-grad.vretta.com, etc., as 
    // production is the most important for eqao-to-bced and we only really care about bced numbers
    
    const targetURL = isGrad ? "https://bced.vretta.com/#/en/ministry-admin/bc-grad/accounts" : 
    "https://bced.vretta.com/#/en/ministry-admin/bc-fsa/accounts";

    window.open(targetURL, '_blank');
  }

  getBaseRoute(){
    return `/${this.lang.c()}/${AccountType.SCHOOL_ADMIN}`;
  }
  getViewRoute(viewSlug:TCView){
    return this.getBaseRoute()+'/'+viewSlug
  }
  
  isWindowSelected(){
    return !!this.myCtrlOrg.selectedWindow
  }

  selectTestWindowFocus(window:ITestWindow) {
    this.myCtrlOrg.selectedWindow = window;
    // this.auth
    //   .apiGet( this.routes.TEST_CTRL_DATA_FILE, this.myCtrlOrg.selectedWindow.ttriFileId, {} )
    //   .then( (file: any) => {
    //     this.ttriUrl = file.secureUrl;
    //   })
    //   .catch(e => {
    //     alert('Cannot make this file available for you.');
    //   });
    this.loadSummaryData();
  }

  currentLang(){
    return this.lang.c();
  }

  renderTimestampAsUIString() {
    const timestamp = this.summaryTableTimestamp;
    const dateFmt = this.lang.tra('datefmt_dashboard_long');
    const timestampFormatted = moment.tz(timestamp, moment.tz.guess()).format(dateFmt);
    return `Summaries Generated At: ${timestampFormatted}`;
  }
  checkActiveWindow(window){
    return (this.myCtrlOrg.selectedWindow === window);
  }
  
  async downloadTransferTable(dataFrame:any, sectionId: number) {
    const tableId = `${sectionId}.${dataFrame.id}`
    const tableRes = await this.auth.apiFind(`${tcDataDlApiPrefix}transfer-table-dl`, {
      query: {
        tc_group_id: 5403,
        test_window_id: this.myCtrlOrg.selectedWindow.id,
        table_id: tableId
      }
    });

    window.open(tableRes[0].secureUrl);
  }
  downloadDataFrame(dataFrame:{apiPath:string}){
    if (this.myCtrlOrg.selectedWindow){
      return this.auth.dataFilePath(tcDataDlApiPrefix+dataFrame.apiPath, {
        test_window_id: this.myCtrlOrg.selectedWindow.id, 
        tc_group_id: this.myCtrlOrg.selectedWindow.test_ctrl_group_id
      });
    }
  }
  renderTwTitle(twTitle:any){
    if (twTitle){
      try {
        const title = JSON.parse(twTitle);
        return title[this.lang.c()] || title['en']
      }
      catch(e){
        return '---'
      }
    }
  }
  renderDate(dateStr){
    return mtz(dateStr).format('MMM D, YYYY')
  }
  // downloadG10DataFrame(dataFrame:{apiPath:string}){
  //   const projectId = this.getCurrentG10ProjectId();
  //   if (projectId == 138 && dataFrame.apiPath == 'registrations/students') {
  //     return this.ttriUrl;
  //   }
  //   return this.auth.dataFilePath(tcDataDlApiPrefix+dataFrame.apiPath, { projectId });
  // }
  getRawLink(userGroupType:any){
    return this.auth.dataFilePath(
      tcDataDlApiPrefix+userGroupType.apiPath, 
      {
        test_window_id: this.myCtrlOrg.selectedWindow.id, 
        tc_group_id: this.myCtrlOrg.selectedWindow.test_ctrl_group_id
      }
    );
  }
  getColLink(userGroupType:string){
    let path = `school-${userGroupType}`;
    if(userGroupType === UserGroupType.SCHOOL_BOARDS) {
      path = 'school-boards';
    } else if (userGroupType === UserGroupType.SCHOOLS) {
      path = 'school';
    }
   return `/en/test-ctrl/${path}`;
  }
  getColValue(userGroupType:string, col:string){
    const colData = this.summaryTable[col];
    if (colData){
      if (colData[userGroupType] !== undefined){
        return transformThousandsSeparator(''+colData[userGroupType], 'en');
      }
    }
    return '--'
  }

  
  async loadTestWindowFiles(){
    // console.log('loadTestWindowFiles')
    this.twFiles = [];
    this.twFiles = await this.myCtrlOrg.getTwFiles()
  }

  loadSummaryData(){
    this.currentSummaryColIndex = 0;
    this.summaryTable = {};
    if (!this.isShowSummaries()){
      return;
    }
    this.loadTestWindowFiles()
    this.loadRemainingSummary();
  }
  // loadG10SummaryData(){
  //   this.currentG10SummaryColIndex = 0;
  //   this.g10SummaryTable = {};
  //   this.loadRemainingG10Summary();
  // }

  getTestWindowId(){
    return this.myCtrlOrg.selectedWindow?.id
  }

  loadRemainingSummary(){
    this.isLoaded = false;
    const col = this.userGroupSummaryColumns[this.currentSummaryColIndex];
    if (!this.myCtrlOrg.selectedWindow){ console.warn('No window selected'); }
    this.myCtrlOrg
      .getSummaries(col.id)
      .then(data => {
        this.isLoaded = true; // after the first one
        this.summaryTable[col.id] = data.summaryData;
        this.currentSummaryColIndex ++;
        this.summaryTableTimestamp = data.timestamp;
        if (this.currentSummaryColIndex < this.userGroupSummaryColumns.length){
          this.loadRemainingSummary();
        }
        else{
          // console.log('summaryTable', this.summaryTable)
        }
      })
  }

  // loadMPTSummaryData(){
  //   return this.auth
  //     .apiGet( this.routes.TEST_CTRL_SUMMARY, 0, {} )
  //     .then( (res:ITCDashboardSummaryRes) => {
  //       this.isLoaded = true;
  //       this.accountSummaries = res.accounts;
  //       this.testWindowSummaries = res.test_windows.map(this.parseTestWindowSummary);

  //       const testWindowIds = res.test_windows.map(window => window.test_window_id);
  //       this.loadSUnclosedSessions(testWindowIds);
  //     })
  //     .catch(e => {
  //       this.isLoadFailed = true;
  //     })
  // }

  loadSUnclosedSessions(testWindowIds) {
    this.auth.apiFind('public/test-ctrl/sessions-date', {
      query: {
        test_window_ids: testWindowIds
      }
    }).then(res => {
      res.data.forEach(sess => {
        const windowId = sess.id;
        const isClosed = sess.is_closed;
        const startDate = sess.date_time_start;

        const start = moment(startDate);
        const now = moment().subtract(6, 'hour');

        if (start.isBefore(now)) {

          if (windowId in this.testWindowOldSessions) {
            if (!isClosed) {
              this.testWindowOldSessions[windowId] += 1;
            }
          } else {
            if (!isClosed) {
              this.testWindowOldSessions[windowId] = 1;
            }
          }

        }
      });

    });
  }

  getCtrlGroup(){
    const ctrlGroups = new Map();
    let bestMatch:{id:number, n:number} | null = null;
    for (let tw of this.testWindows){
      const id = tw.test_ctrl_group_id;
      const n = (ctrlGroups.get(id)|| 0) + 1
      ctrlGroups.set(id, n);
      if (bestMatch){
        if (n > bestMatch.n){
          bestMatch = {id, n}
        }
      }
      else {
        bestMatch = {id, n}
      }
    }
    const ctrlGroupUniqIds:number[] = [];
    ctrlGroups.forEach((n, id) => {
      ctrlGroupUniqIds.push(+id);
    });
    console.log('ctrlGroups', ctrlGroups)
    const bestMatchId = bestMatch?.id;
    const test_ctrl_group_id = prompt(`The test window will be assigned to a control group. Previous windows have been assigned to the following control groups: ${ctrlGroupUniqIds}. The most frequently used control group is ${bestMatch ? bestMatchId : '(NONE)'}.`, ''+bestMatchId) 

    if (!test_ctrl_group_id){
      throw new Error('NO_test_ctrl_group_id');
    }

    return +test_ctrl_group_id;
  }

  promptForUserInput(): 0 | 1
  {
    // prompt for if test window is sample or not
    let userInput = prompt('Answer this question accurately: is this test window only an internal/sample test window (yes/no)?');
    if (!["yes", "no"].includes(userInput.toLocaleLowerCase()))
    {
      alert("Please type only yes or no.");
      this.promptForUserInput();
    }

    return userInput.toLocaleLowerCase() === "yes" ? 1 : 0; 
  }

  promptForFieldTrial() {
    let userInput = prompt('Answer this question accurately: is this a field trial test window (yes/no)?');
    if (!["yes", "no"].includes(userInput.trim().toLocaleLowerCase())) {
      alert("Please type only yes or no.");
      this.promptForFieldTrial();
    }

    return userInput.trim().toLocaleLowerCase() === "yes" ? 1 : 0; 
  }

  createTestWindow(){
    const test_ctrl_group_id = this.getCtrlGroup();

    if (confirm('Proceed in creating a new test window?'))
    {
      const isSample = this.promptForUserInput();
      const is_field_trial = this.promptForFieldTrial();
      return this.auth
        .apiCreate(this.routes.TEST_CTRL_TEST_WINDOW_SUMMARY, 
        {
          isSample,
          test_ctrl_group_id,
          is_field_trial,
        })
        .then( (res:{id:number, test_ctrl_group_id:number} ) => {
          this.router.navigate([ this.getTestWindowRoute(res) ])
        })
        .catch(e => {
          alert('Cannot create new test window.')
        })
    }
    }

  isLangReqLoaded:boolean;
  isLangReqLoading:boolean;
  isLangReqLoadFailed:boolean;
  langReqRows:ILangReqRow[] = [];
  loadLangReqData(){
    this.langReqRows = []
    this.isLangReqLoading = true;
    return this.auth
      .apiFind( this.routes.TEST_CTRL_LANG_REQ, {} )
      .then( (res:any) => { // :Paginated
        this.isLangReqLoaded = true;
        this.langReqRows = res.data.map(this.parseLangReqRecord);
        this.isLangReqLoading = false;
        // console.log('loadLangReqData', this.langReqRows)
      })
      .catch(e => {
        this.isLangReqLoadFailed = true;
      })
  }


  isInstSummaryLoaded:boolean;
  isInstSummaryLoading:boolean;
  isInstSummaryLoadFailed:boolean;
  instSummaryList:any[] = [];
  loadInstSummary(){
    this.instSummaryList = []
    this.isInstSummaryLoading = true;
    return this.auth
      .apiFind( this.routes.TEST_CTRL_ACCOUNTS_INSTITUTIONS, {} )
      .then( (res:any) => { // :Paginated
        this.isInstSummaryLoaded = true;
        this.instSummaryList = res.data.sort((a,b)=>{
          if (a.name > b. name){ return 1; }
          if (a.name < b. name){ return -1; }
          return 0;
        });
        this.isInstSummaryLoading = false;
      })
      .catch(e => {
        this.isInstSummaryLoadFailed = true;
      })
  }

  parseLangReqRecord = (langReqRecord:ILangReqRecord) : ILangReqRow => {
    const DATE_FMT = 'MMM D, YYYY'
    const TIME_FMT = this.lang.tra('datefmt_time')
    const m = moment(langReqRecord.date_time_start);
    return {
      testSessionId: langReqRecord.id,
      date: m.format(DATE_FMT),
      time: m.format(TIME_FMT),
      location:langReqRecord.city,
      locationInst: langReqRecord.institution_name,
      locationDetails: [
        `${langReqRecord.room}, ${langReqRecord.campus_building}`,
        `${langReqRecord.address}`,
        `${langReqRecord.city} ${langReqRecord.province} ${langReqRecord.postal_code}`,
        `${langReqRecord.phone_number}`,
      ].join('\n'),
      lang: this.processLangReqCode(langReqRecord.lang_req),
      tally: langReqRecord.tally,
      isOrganized: false,
      notes: '',
      __notesInput: new FormControl(),
    }
  }

  private processLangReqCode(langCode:string){
    if (langCode === 'fr'){
      return 'French';
    }
    return 'Other';
  }

  parseTestWindowSummary = (tws:ITestWindowSummary) : ITestWindow => {
    const dateFmt = this.lang.tra('datefmt_dow_time_day_month_year');
    const dateStart = moment.tz(tws.test_window_date_start, moment.tz.guess()).format(dateFmt);
    const dateEnd = moment.tz(tws.test_window_date_end, moment.tz.guess()).format(dateFmt);
    return {
      id: tws.test_window_id,
      test_ctrl_group_id: tws.test_ctrl_group_id, // might be missing
      captionStr: tws.test_window_name ? tws.test_window_name[this.lang.c()] : '',
      dateStart,
      dateEnd,
      numSessionsCreated: tws.num_sessions_created,
      numSessionsAdministered: tws.num_sessions_administered,
      numResultsPendingRelease: tws.num_results_pending_release,
    }
  }

  // DOM utility
  disabled(){
    if (!this.isDisableHidden){
      this.loginGuard.confirmationReqActivate({
        caption: this.lang.tra('txt_feature_disabled'),
        confirm: ()=>{}
      })
    }
  }

  getTestWindowRoute = (window:ITestWindow) => {
    return `/${this.lang.c()}/${AccountType.TEST_CTRL}/test-window/ctrl-group/${window.test_ctrl_group_id}/window/${window.id}` ;
  }

  refreshData(){

  }

  getAccountsRoute(){
    return `/${this.lang.c()}/${AccountType.TEST_CTRL}/accounts/${AccountType.TEST_ADMIN}`;
  }

  isTestCtrlReportingExplorerEnabled(){
    return this.whitelabel.getSiteFlag('TEST_CTRL_REPORT_EXPLR');
  }
  
  
  isShowSummaries(){
    return this.whitelabel.getSiteFlag('IS_TC_SUMM');
  }
  isShowDataDownloads(){
    return this.whitelabel.getSiteFlag('IS_TC_DATA') && !this.IS_DOWNLOADS_DISABLED;
  }

    // testWindowSummaries

  // renderTwTitle(tw:ITestWindow){
  //   return tw.captionStr;
  // }
  renderTwDateStart(tw:ITestWindow){
    return tw.dateStart;
  }
  renderTwDateEnd(tw:ITestWindow){
    return tw.dateEnd;
  }
  renderTwNumSessionsCr(tw:ITestWindow){
    return tw.numSessionsCreated;
  }
  renderOldUnclosed(tw:ITestWindow) {
    return this.testWindowOldSessions[tw.id] || 0;
  }
  renderTwNumSessionsAdm(tw:ITestWindow){
    return tw.numSessionsAdministered;
  }
  renderTwNumResPend(tw:ITestWindow){
    return tw.numResultsPendingRelease;
  }
  // end of: testWindowSummaries
  // Account Summaries
  renderAccountTally(set:string, subset: 'r' | 'l30' | 'p'){
    let val;
    if (this.accountSummaries){
      const tallySummary = this.accountSummaries[set];
      if (tallySummary){
        val = tallySummary[subset];
      }
    }
    return val || 0;
  }


  // end of: Account Summaries
  renderDateFromStr(dateString:string){
    return moment.tz(dateString, moment.tz.guess()).format();
  }
  isOnFirstPage(){
    return true;
  }
  isOnLastPage(){
    return true;
  }
  getCurrentPageNum(){
    return 1
  }
  getMaxPages(){
    return 1
  }


}
